import { array, partial, string } from 'io-ts/Decoder';

import { Id as GroupId } from '../../../../../../whole-house/canvas/group/Id';

export const Request = partial({
	name: string,
	parentId: GroupId,
	layerIds: array(string),
});
